module.exports = __webpack_public_path__ + "static/portfolio-mas-11-50430288040904c6be1083d3a1223f6c.jpg";